import { useEffect, useState } from 'react';

import { useVisitorId } from '@xing-com/hub';

export const generateLink = (
  link: string,
  params?: Record<string, string>
): string => {
  const [path, query] = link.split('?');
  const queryParams = new URLSearchParams(query);
  const additionalParams = new URLSearchParams(params);
  const newQueryParams = new URLSearchParams([
    ...queryParams,
    ...additionalParams,
  ]).toString();

  return `${path}${newQueryParams ? '?' : ''}${newQueryParams}`;
};

// Use generated link only after initial render, for SEO reasons
export const useGeneratedLink = (
  link: string,
  params?: Record<string, string>
): string => {
  const [resultingLink, setResultingLink] = useState(link);
  const visitorId = useVisitorId();

  const [path] = link.split('?');

  const isKununuOrOnlyfy = ['kununu', 'onlyfy'].some((domain) =>
    path.includes(domain)
  );

  const scCdvidParam: Record<string, string> = isKununuOrOnlyfy
    ? { sc_cdvid: encodeURIComponent(btoa(visitorId)) }
    : {};

  const generatedLink = generateLink(link, { ...params, ...scCdvidParam });

  useEffect(() => {
    setResultingLink(generatedLink);
  }, [generatedLink]);

  return resultingLink;
};
